import { COLORS } from "@/packages/theme/tokens";
import { Center, chakra, Flex } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { Button } from "../button";
import { useOpacitySlide } from "./hooks/useOpacitySlide";
import { type OpacitySlideProps } from "./types/opacitySlide.type";

export const OpacitySlide = ({
    isScale = true,
    isControls = true,
    imgList,
    autoPlay = true,
    time = 5900,
    opacityTime = 0.3,
    scaleTime = 5,
    children,
    ease = "easeIn",
}: OpacitySlideProps) => {
    const { currentIdx, nextSlide, prevSlide, playAuto, stopAuto, isPlaying, ref } = useOpacitySlide({
        imgList,
        time,
        autoPlay,
    });
    return (
        <Center ref={ref} position="relative" w="100%" h="100%" overflow="hidden">
            {imgList.map((img, index) => (
                <MotionOpacityContainer
                    key={`${img.imgUrl}`}
                    position="absolute"
                    w="100%"
                    h="100%"
                    initial={{ opacity: index === currentIdx ? 1 : 0 }}
                    animate={{
                        opacity: index === currentIdx ? 1 : 0,
                        transition: { duration: opacityTime, ease },
                    }}
                >
                    <MotionOpacityImg
                        position="absolute"
                        w="100%"
                        h="100%"
                        background={`url(${img.imgUrl}) no-repeat center/cover`}
                        animate={{
                            // scale: isScale && autoPlay && index === currentIdx ? [1, 1.2] : 1,
                            transition: {
                                duration: isScale ? scaleTime : 0,
                                delay: isScale ? opacityTime : 0,
                            },
                        }}
                    />
                </MotionOpacityContainer>
            ))}
            <Center w="100%" h="100%" maxW="1600px" paddingX="24px" flexDir="column" zIndex="1" rowGap="48px">
                {children && children}
                {isControls && (
                    <Flex w="100%" justifyContent="flex-start" columnGap="16px">
                        <CustomControlButton iconNamed="navigate_before" onClick={prevSlide} />
                        <CustomControlButton isPlaying={isPlaying} iconNamed="play_arrow" onClick={playAuto} />
                        <CustomControlButton isPlaying={!isPlaying} iconNamed="pause" onClick={stopAuto} />
                        <CustomControlButton iconNamed="navigate_next" onClick={nextSlide} />
                    </Flex>
                )}
            </Center>
        </Center>
    );
};

const MotionOpacityContainer = chakra(motion.div);
const MotionOpacityImg = chakra(motion.div);

const CustomControlButton = styled(Button)<{ isPlaying?: boolean }>`
    width: 48px;
    border: 1px solid ${COLORS.white};
    border-radius: 50%;
    color: ${({ isPlaying }) => (isPlaying ? COLORS.gray[400] : COLORS.white)};
    background-color: ${({ isPlaying }) => (isPlaying ? COLORS.transparent.w80 : "none")};
`;
